import { connect } from 'react-redux'
import Checkbox from './Checkbox.js';
import { changeFilter } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({
	checked: state.filter[ownProps.value]
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: (event) => dispatch(changeFilter(ownProps.value))
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkbox);


// WEBPACK FOOTER //
// ./src/components/Filter/FilterCheckboxContainer.js